export enum TaskStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  ON_APPROVAL = 'on_approval',
  COMPLETED = 'completed',
}

export enum TaskType {
  DEADLINE_BASED = 'deadline_based',
  TIME_BASED = 'time_based',
}

export enum RepeatOption {
  NO_REPEAT = 'no_repeat',
  EACH_YEAR = 'each_year',
  EACH_MONTH = 'each_month',
  EACH_WEEK = 'each_week',
  EACH_DAY = 'each_day',
  SPECIFIC_DAYS = 'specific_days',
}

export const TASK_STATUSES = [
  { id: TaskStatus.PENDING, label: 'Pending' },
  { id: TaskStatus.IN_PROGRESS, label: 'In Progress' },
  // { id: 'on_hold', label: 'On hold' },
  { id: TaskStatus.ON_APPROVAL, label: 'In Review' },
  { id: TaskStatus.COMPLETED, label: 'Completed' },
  // { id: 'cancelled', label: 'Cancelled' },
  // { id: 'failed', label: 'Failed' },
] as const;

export const TASK_TYPES = [
  { id: TaskType.DEADLINE_BASED, label: 'Deadline-Based' },
  { id: TaskType.TIME_BASED, label: 'Time-Based' },
] as const;

export const REPEAT_OPTIONS = [
  { id: RepeatOption.NO_REPEAT, label: 'No Repeat' },
  { id: RepeatOption.SPECIFIC_DAYS, label: 'Specific Days' },
  { id: RepeatOption.EACH_DAY, label: 'Each Day' },
  { id: RepeatOption.EACH_WEEK, label: 'Each Week' },
  { id: RepeatOption.EACH_MONTH, label: 'Each Month' },
  { id: RepeatOption.EACH_YEAR, label: 'Each Year' },
] as const;
